import { SkeletonBlock } from '../SkeletonLoader';
import { Cell, Row } from 'react-aria-components';
import styles from './DataTable.module.scss';
import { buildStickyProps, useStickyColumnsContext } from './useStickyColumns';

export type BetaDataTableRowLoaderProps = {
  /** Number of columns to render skeleton cells for */
  columns: number;
  /** Number of skeleton rows to display */
  rows?: number;
  /** Whether to show a checkbox skeleton in each row */
  showCheckboxes?: boolean;
};

export const BetaDataTableRowLoader = ({
  columns,
  rows = 1,
  showCheckboxes,
}: BetaDataTableRowLoaderProps) => {
  const { getStickyInfo, canScrollLeft, canScrollRight, checkboxOffset } =
    useStickyColumnsContext();

  const cbStickyProps = showCheckboxes
    ? buildStickyProps({
        info: getStickyInfo(0),
        canScrollLeft,
        canScrollRight,
      })
    : {};
  const { style: cbStickyStyle, ...cbStickyDataAttrs } = cbStickyProps;

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Row className={styles.tr} key={`row-${rowIndex}`}>
            {showCheckboxes && (
              <Cell
                className={styles.checkboxCell}
                style={cbStickyStyle}
                {...cbStickyDataAttrs}
              >
                <SkeletonBlock width={24} height={24} />
              </Cell>
            )}
            {Array.from({ length: columns }).map((_, colIndex) => {
              const absIdx = colIndex + checkboxOffset;
              const { style: stickyStyle, ...stickyDataAttrs } =
                buildStickyProps({
                  info: getStickyInfo(absIdx),
                  canScrollLeft,
                  canScrollRight,
                });

              return (
                <Cell
                  key={`col-${colIndex}`} // eslint-disable-line react/no-array-index-key
                  style={stickyStyle}
                  {...stickyDataAttrs}
                >
                  <SkeletonBlock height={20} />
                </Cell>
              );
            })}
          </Row>
        );
      })}
    </>
  );
};
